import { create } from "zustand";
import { leitenRequest } from "../../leiten/controllers/leitenRequest";
import { ApiCustomerMe } from "../../requests/getUserInfo";
export const useUserInfoStore = create(() => ({
    userInfo: null,
}));
export const useUserInfo = leitenRequest(useUserInfoStore, "userInfo", async (_) => {
    const result = await ApiCustomerMe.get();
    const oldResult = useUserInfoStore.getState().userInfo;
    if (JSON.stringify(oldResult) === JSON.stringify(result))
        return oldResult;
    return result;
});
